// Permisos que el backend devuelve en `/verify-token` (`authContext.permissions`).
// Ocultar un botón no es la defensa: cada endpoint vuelve a comprobarlo.

export const DOWNLOAD_DESIGN_FILES = 'CustomizedKeyring.download_design_files';

// Uno por customizador, con la clave de producto del registry (C3D-27).
export const CUSTOMIZER_PERMISSIONS = {
    keyring: 'CustomizedKeyring.use_customizer_keyring',
    lightbox: 'CustomizedKeyring.use_customizer_lightbox',
    napkin_panel: 'CustomizedKeyring.use_customizer_napkin_panel',
    napkin_bubble: 'CustomizedKeyring.use_customizer_napkin_bubble',
};

const isAdmin = (authContext) => authContext?.role === 'admin';

const hasPermission = (authContext, permission) => (
    Boolean(authContext?.permissions?.includes(permission))
);

/**
 * ¿Puede descargar los ficheros de impresión de un diseño (3MF, STL, Orca)?
 * Administración siempre; el resto según el permiso del grupo de su rol
 * (C3D-27: de inicio, el rol editor). Quien compra descarga por su compra.
 */
export function canDownloadDesignFiles(authContext) {
    return isAdmin(authContext) || hasPermission(authContext, DOWNLOAD_DESIGN_FILES);
}

/**
 * ¿Puede crear y editar diseños con este customizador? Lo decide el panel de
 * roles; administración siempre. Ver lo ya hecho no depende de esto.
 */
export function canUseCustomizer(authContext, productType) {
    const permission = CUSTOMIZER_PERMISSIONS[productType];
    return isAdmin(authContext) || Boolean(permission && hasPermission(authContext, permission));
}

// Proyectos comerciales y catálogos (C3D-38). El primero deja llevar lo que uno
// tiene asignado (rol comercial); el segundo, todo.
export const MANAGE_PROJECTS = 'crm.manage_projects';
export const MANAGE_ALL_PROJECTS = 'crm.manage_all_projects';

/** ¿Puede entrar a Proyectos, Leads y Clientes del panel? */
export function canManageProjects(authContext) {
    return isAdmin(authContext)
        || hasPermission(authContext, MANAGE_PROJECTS)
        || hasPermission(authContext, MANAGE_ALL_PROJECTS);
}

/** ¿Ve todos los proyectos y puede reasignarlos, o solo los suyos? */
export function canManageAllProjects(authContext) {
    return isAdmin(authContext) || hasPermission(authContext, MANAGE_ALL_PROJECTS);
}
